var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"textarea-wrapper"},[_c('font-awesome-icon',{attrs:{"icon":_vm.icon}}),_c('textarea',{attrs:{"placeholder":_vm.placeholder,"required":""},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}}),_c('label',[_vm._v(_vm._s(_vm.placeholder))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }